import styled from 'styled-components'

const FormattedHtmlContent = styled.div<{ noMargin?: boolean }>`
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.125rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-left: 1.5rem;
    margin-bottom: 1.5rem;
    @media (min-width: 768px) {
      margin-left: 2.5rem;
      margin-bottom: 2rem;
    }
  }
  li {
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;
    @media (min-width: 768px) {
      padding-left: 2rem;
    }
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.6em;
      width: 0.5rem;
      height: 0.5rem;
      background-color: #F04248;
      border-radius: 2px;
    }
  }
  p {
    margin-bottom: ${(props) => (props.noMargin ? '0 !important' : '1.5rem')};
    @media (min-width: 768px) {
      margin-bottom: ${(props) => (props.noMargin ? '0 !important' : '2rem')};
    }
  }
  p:has(+ h5) {
    margin-bottom: 0.5rem;
    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }
  h1, h2, h3, h4, h5, h6 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-weight: 700;
    @media (min-width: 768px) {
      margin-top: 3rem;
      margin-bottom: 1.5rem;
    }
  }
  h4 {
    font-size: 1.125rem;
    margin-top: 1.5rem;
    margin-bottom: 0.25rem;
    @media (min-width: 768px) {
      font-size: 1.25rem;
      margin-top: 2rem;
      margin-bottom: 0.35rem;
    }
  }
  h5 {
    font-size: 1rem;
    margin-top: 0.75rem;
    margin-bottom: 0rem;
    @media (min-width: 768px) {
      font-size: 1.125rem;
      margin-top: 1rem;
      margin-bottom: 0.05rem;
    }
  }
  a {
    text-decoration: underline;
    color: #F04248;
  }
`

export default FormattedHtmlContent
